// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3Ewnc","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__XUU33"};